import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { FaCheckCircle, FaClock, FaPhoneAlt, FaEnvelope, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./ThankYouPage.css";

const ThankYouPage = () => {
  const backgroundUrl = `${process.env.PUBLIC_URL}/header-image.jpg`;
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("");
    }, 10000); // Redirect after 10 seconds

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      className="thankyoupage-section"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(9, 41, 72, 0.9) 0%, rgba(2, 174, 239, 0.8) 100%), url(${backgroundUrl})`,
      }}
    >
      <div className="thankyoupage-container">
        <motion.div
          className="thankyoupage-card"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <div className="thankyoupage-decoration-circle" />
          <div className="thankyoupage-decoration-dots" />

          <div className="thankyoupage-icon-wrapper">
            <FaCheckCircle className="thankyoupage-icon" />
            <div className="thankyoupage-icon-circle" />
          </div>

          <h1 className="thankyoupage-title">
            <span className="thankyoupage-title-gradient">Thank You for Reaching Out to Greenworks Carpet Cleaning</span>
          </h1>

          <p className="thankyoupage-subtitle">
            Thank you for contacting Greenworks Carpet Cleaning. We've received your message, 
            and our team will be in touch with you soon.
          </p>

          <motion.div 
            className="thankyoupage-timer"
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, repeatType: "reverse", duration: 1.5 }}
          >
            <FaClock className="thankyoupage-timer-icon" />
            <span>We'll respond within 24 hours</span>
          </motion.div>

          <div className="thankyoupage-details">
            <p className="thankyoupage-description">
              Whether you have a question, need a quote, or want to schedule a service, 
              we're here to help. If you'd prefer to speak with someone directly, 
              feel free to reach out using the contact options below:
            </p>

            <div className="thankyoupage-contact-method">
              <div className="thankyoupage-contact-icon">
                <FaPhoneAlt />
              </div>
              <div className="thankyoupage-contact-info">
                <h4>Call Us</h4>
                <a href="tel:+12068996862" className="thankyoupage-contact-link">
                  +1 (206) 899-6862
                </a>
              </div>
            </div>

            <div className="thankyoupage-contact-method">
              <div className="thankyoupage-contact-icon">
                <FaEnvelope />
              </div>
              <div className="thankyoupage-contact-info">
                <h4>Email Us</h4>
                <a href="mailto:info@greenworkscarpetcleaning.com" className="thankyoupage-contact-link">
                  info@greenworkscarpetcleaning.com
                </a>
              </div>
            </div>
          </div>

          <p className="thankyoupage-about">
            Greenworks Carpet Cleaning is proud to offer eco-friendly, professional cleaning 
            services for carpets, upholstery, tile, and more. We're committed to delivering 
            high-quality results and excellent customer care.
          </p>

          <p className="thankyoupage-explore">
            In the meantime, feel free to explore our website to learn more about our services 
            and see what sets us apart.
          </p>

          <p className="thankyoupage-closing">
            We appreciate your interest and look forward to connecting with you.
          </p>

          <button 
            className="thankyoupage-button"
            onClick={() => navigate("/")}
          >
            <span className="thankyoupage-button-text">
              <FaHome /> Back To Homepage
            </span>
            <span className="thankyoupage-button-hover" />
          </button>

          <div className="thankyoupage-footer">
            <p>Greenworks Carpet Cleaning - Eco-friendly cleaning solutions for your home and business</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ThankYouPage;